import { HttpBackend, HttpEvent, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injector } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { filter, map, Observable } from 'rxjs';

export class CustomTranslateLoader implements TranslateLoader {
  contentHeader = new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    skip: 'true',
  });

  constructor(private httpHandler: HttpBackend, private injector: Injector) {}
  getTranslation(lang: string): Observable<any> {
    const baseUrl = this.injector.get<string>('BASE_URL' as any, '/');
    const apiAddress = baseUrl + 'api/dictionary/' + lang;

    const httpRequest = new HttpRequest('GET', apiAddress, { headers: this.contentHeader });

    return this.httpHandler.handle(httpRequest)
      .pipe(
        filter((httpEvent: HttpEvent<any>) => httpEvent instanceof HttpResponse),
        map((httpResponse: HttpResponse<any>) => httpResponse.body)
      )
  }
}
